import React, {
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";

import { SET_IS_LOADING as SET_IS_LOADING_ACTION } from "Redux/actionTypes";

import {
  Row,
  Col,
  Tab,
  Nav,
  CustomContainer,
  useRouter
} from "components/atoms/DependencyHelper";

import {
  link as AnalyticsLink,
  getUtagData as AnalyticsGetUtagData
} from "services/analyticsUtag";

import DealListCarousel from "./DealListCarousel";
import styles from "./DealDetailFooterBottom.module.scss";

import config from "../../../config";
import labels from "../../../config/labels";

const DealDetailsFooterBottom = () => {
  const relatedDeals = useSelector((state) => state.dealDetails.relatedDeals);
  const similarDeals = useSelector((state) => state.dealDetails.similarDeals);

  const [activeTab, setActiveTab] = useState("SMP");
  const [analytics, setAnalytics] = useState(false);
  const [tabData, setTabData] = useState(
    Array.isArray(similarDeals) ? similarDeals : []
  );
  const env = config.env;
  const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;
  const router = useRouter();

  const tabNames = [
    {
      key: "SMP",
      title: "Similar deals",
    },
    {
      key: "RLP",
      title: "You might also like",
    },
  ];

  const dispatch = useDispatch();
  const setLoadingState = (isLoading) => dispatch({
    type: SET_IS_LOADING_ACTION,
    payload: isLoading
  });

  const getTabTitle = (eventKey, tabNames) => {
    let total = tabNames.length;
    for (let i = 0; i < total; i++) {
      if (eventKey === tabNames[i].key) {
        return tabNames[i].title;
      }
    }
  };

  function getCrossSellData(key) {
    setActiveTab(key);

    switch (key) {
      case "SMP":
        Array.isArray(similarDeals)
          ? setTabData(similarDeals.slice(0, labels.productBottomFooterTabs.max_products))
          : setTabData([]);
        break;
      case "RLP":
        Array.isArray(relatedDeals)
          ? setTabData(relatedDeals.slice(0, labels.productBottomFooterTabs.max_products))
          : setTabData([]);
        break;
      default:
        setTabData([]);
        break;
    }

    AnalyticsLink({
      ...AnalyticsGetUtagData([
        "page_channel",
        "page_master_tab",
        "sales_product_id",
        "sales_product_price",
        "sales_product_quantity",
        "visitor_login_status",
        "visitor_msisdn_hash",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_subscription_type",
        "page_site_section_lvl_1",
        "page_site_section_lvl_2",
        "page_site_section_lvl_3",
        "page_site_section_lvl_4"
      ]),
      page_tool_event: "use",
      page_tool_name: `shopping: devices: deal details: ${getTabTitle(
        key,
        tabNames
      )}`,
      link_name: `shopping: devices: deal details: ${getTabTitle(
        key,
        tabNames
      )}`,
      link_type: "use",
      page_name: "shopping: devices: deal details",
    });
  }

  const onSeeDetailsClick = (item) => {
    let contracts = item.contract_sku;

    if (!Array.isArray(contracts)) {
      contracts = [`${contracts}`];
    }

    setLoadingState(true);

    const buyOption = router?.query?.buyOption ?router?.query?.buyOption : false;

    router
      .push({
        pathname: `${urlPrefix}/deal-details-page/${item.sku}`,
        query: buyOption ? { contractSkus: contracts, buyOption: buyOption}:{ contractSkus: contracts},
      })
      .then(() => {
        window.scrollTo(0, 0);
        // setLoadingState(false);
      });

    if (!analytics) {
      AnalyticsLink({
        ...AnalyticsGetUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_msisdn_hash",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_subscription_type",
          "page_site_section_lvl_1",
          "page_site_section_lvl_2",
          "page_site_section_lvl_3",
          "page_site_section_lvl_4"
        ]),
        link_type: "use",
        link_name: "shopping: deal details: view recommended deal",
        page_name: "shopping: deal selection: build your contract" ,
      });
      setAnalytics(true);
    }
  };

  return (
    <div>
      <CustomContainer className={`${tabData?.length > 0 ? styles["footer-product-divder"]: ""}`} />

      { (similarDeals?.length > 0 || relatedDeals?.length > 0 ) &&
        <CustomContainer className={`mt-xl ${styles["footer-product-container"]} p-0`}>
          <Row>
            <Col xs={12}>
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey={tabNames[0].key}
                onSelect={(eventKey) => getCrossSellData(eventKey)}
              >
                <Row>
                  <Col xs={12} className={`${styles["tabs-design"]}`}>
                    <Nav variant="tabs" className={`${styles["tabs-design__nav"]}`}>
                      { tabNames.map((tab, index) => (
                        <Nav.Item key={index}>
                          <Nav.Link
                            eventKey={tab.key}
                            bsPrefix={`${styles["tab-link"]} ${
                              activeTab === tab.key
                                ? styles["tab-link--active"]
                                : ""
                            }`}
                          >
                            {tab.title}
                          </Nav.Link>
                        </Nav.Item>
                      )) }
                    </Nav>
                    <CustomContainer className={`${styles['nav-line-seperator']}`} />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12}>
                    <Tab.Content className={`${styles["tab-content"]} pt-m `}>
                      { tabNames.map((tab, index) => (
                        <Tab.Pane eventKey={tab.key} key={index}>
                          <DealListCarousel
                            dealList={tabData}
                            onSeeDetailsClick={onSeeDetailsClick}
                          />
                        </Tab.Pane>
                      )) }
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Row>
        </CustomContainer>
      }
    </div>
  );
};

DealDetailsFooterBottom.propTypes = { };

export default DealDetailsFooterBottom;
